export const formatToLakhs = (amount: number | string): string => {
  const num = Number(amount);
  if (isNaN(num)) return "0";

  const lakhs = num / 100000;

  return lakhs?.toFixed(1);
};

export const formatCurrencyINR = (
  amount: string | number,
  round: boolean = true
): string => {
  const parsed = Number(amount);
  if (isNaN(parsed)) return "₹0";

  const value = round ? Math.round(parsed) : parsed;

  return value.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: round ? 0 : 2,
  });
};

export function cleanFloat(value: number, decimals: 0 | 1 | 2 = 0): number {
  if (decimals === 0) {
    return Math.round(value);
  }
  return Number(value?.toFixed(decimals));
}

export const formatSavingsK = (amount: number): string => {
  const parsed = Number(amount);
  if (isNaN(parsed)) return "₹0k";
  return `₹${Math.floor(parsed / 1000)}k`;
};

export const formatPrice = (value: number) => {
  if (value >= 10000000) {
    const inCrores = value / 10000000;
    return `₹${inCrores.toFixed(1)} Cr`;
  } else if (value >= 100000) {
    const inLakhs = value / 100000;
    return `₹${inLakhs.toFixed(1)} L`;
  } else {
    return `₹${value.toLocaleString("en-IN")}`;
  }
};

export const formatPriceLong = (value: number) => {
  if (value >= 10000000) {
    const inCrores = value / 10000000;
    return `₹${inCrores.toFixed(1)} crore`;
  } else if (value >= 100000) {
    const inLakhs = value / 100000;
    return `₹${inLakhs.toFixed(1)} lakh`;
  } else {
    return `₹${value.toLocaleString("en-IN")}`;
  }
};


export function maskAmount(amount: number | string): string {
  amount = Number(amount);
  const formatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  });

  const formatted = formatter.format(amount);
  const parts = formatted.split(",");

  if (parts.length === 1) {
    return `₹XX${parts[0]}`;
  }

  const maskedParts = parts.map((part, index) =>
    index === parts.length - 1 ? part : "XX"
  );

  return `₹${maskedParts.join(",")}`;
}

export const formatToLakhsRounded = (amount: number | string): number => {
  const num = Number(amount);
  if (isNaN(num)) return 0;

  const lakhs = num / 100000;

  return Math.round(lakhs);
};

export function numberToWords(num: number): string {
  const words = [
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
    "twenty",
  ];
  if (num >= 0 && num <= 20) {
    return words[num];
  }
  return num.toString();
}
